"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YieldControllerClient = exports.confirm = exports.setUpAnchor = exports.PROGRAM_ID = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const anchor = __importStar(require("@coral-xyz/anchor"));
const web3_js_1 = require("@solana/web3.js");
const treasury_controller_1 = require("./types/treasury_controller");
const spl_token_1 = require("@solana/spl-token");
exports.PROGRAM_ID = new web3_js_1.PublicKey("stcGmoLCBsr2KSu2vvcSuqMiEZx36F32ySUtCXjab5B");
const setUpAnchor = () => {
    // Configure the client to use the local cluster.
    const provider = anchor_1.AnchorProvider.env();
    anchor.setProvider(provider);
    return provider;
};
exports.setUpAnchor = setUpAnchor;
const confirm = (connection) => (txSig) => __awaiter(void 0, void 0, void 0, function* () {
    return connection.confirmTransaction(Object.assign({ signature: txSig }, (yield connection.getLatestBlockhash())));
});
exports.confirm = confirm;
class YieldControllerClient {
    constructor(provider) {
        this.provider = provider;
        this.program = new anchor_1.Program(treasury_controller_1.IDL, exports.PROGRAM_ID, provider);
    }
    init(stateAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = yield this.program.account.state.fetch(stateAddress);
            this.config = {
                updateAuthority: state.updateAuthority,
                treasury: state.treasury,
                mint: state.mint,
                purchaseThreshold: state.purchaseThreshold,
                purchaseProportion: state.purchaseProportion,
                bump: state.bump,
            };
            this.stateAddress = stateAddress;
        });
    }
    static getStateAddress(mint, index) {
        const [state] = web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("state"), mint.toBuffer(), Buffer.from([index])], exports.PROGRAM_ID);
        return state;
    }
    static calculateYieldAccount(stateAddress) {
        return web3_js_1.PublicKey.findProgramAddressSync([Buffer.from("yield_account"), stateAddress.toBuffer()], exports.PROGRAM_ID);
    }
    static get(provider, stateAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const client = new YieldControllerClient(provider);
            yield client.init(stateAddress);
            return client;
        });
    }
    getState() {
        if (!this.stateAddress)
            throw new Error("Client not initialised");
        return this.program.account.state.fetch(this.stateAddress);
    }
    static getYieldAccount(stateAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            return YieldControllerClient.get((0, exports.setUpAnchor)(), stateAddress).then(client => client.getState());
        });
    }
    static register(updateAuthority, treasury, mint, holdingAccount, holdingTokenAccount, price, purchaseProportion, purchaseThreshold, index) {
        return __awaiter(this, void 0, void 0, function* () {
            // find state address
            const state = this.getStateAddress(mint, index);
            const client = new YieldControllerClient((0, exports.setUpAnchor)());
            const [, yieldAccountBump] = YieldControllerClient.calculateYieldAccount(state);
            const accounts = {
                payer: client.provider.wallet.publicKey,
                state,
                mint,
                systemProgram: web3_js_1.SystemProgram.programId,
            };
            const args = {
                mint,
                updateAuthority,
                treasury,
                holdingAccount,
                holdingTokenAccount,
                price,
                purchaseProportion,
                purchaseThreshold,
                index,
                yieldAccountBump,
            };
            console.log({ accounts, args });
            yield client.program.methods
                .registerState(args)
                .accounts(accounts)
                .rpc()
                .then(() => {
                (0, exports.confirm)(client.provider.connection);
            });
            yield client.init(state);
            return client;
        });
    }
    static updateController(state, updateAuthority, treasury, mint, holdingAccount, holdingTokenAccount, price, purchaseProportion, purchaseThreshold, index) {
        return __awaiter(this, void 0, void 0, function* () {
            const client = new YieldControllerClient((0, exports.setUpAnchor)());
            const accounts = {
                payer: client.provider.publicKey,
                state,
            };
            const [, yieldAccountBump] = YieldControllerClient.calculateYieldAccount(state);
            yield client.program.methods
                .updateState({
                mint,
                updateAuthority,
                treasury,
                holdingAccount,
                holdingTokenAccount,
                price,
                purchaseProportion,
                purchaseThreshold,
                index,
                yieldAccountBump,
            })
                .accounts(accounts)
                .rpc()
                .then((0, exports.confirm)(client.provider.connection));
            yield client.init(state);
            return client;
        });
    }
    static allocateYield(payer, stateAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const client = new YieldControllerClient((0, exports.setUpAnchor)());
            // TODO make non-static and fix return value
            const state = yield YieldControllerClient.getYieldAccount(stateAddress);
            const [yieldAccount] = YieldControllerClient.calculateYieldAccount(stateAddress);
            const accounts = {
                payer,
                state: stateAddress,
                mint: state.mint,
                treasury: state.treasury,
                holdingAccount: state.holdingAccount,
                holdingTokenAccount: state.holdingTokenAccount,
                yieldAccount,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                systemProgram: web3_js_1.SystemProgram.programId,
            };
            console.log(accounts);
            yield client.program.methods
                .allocateYield()
                .accounts(accounts)
                .rpc()
                .then((0, exports.confirm)(client.provider.connection));
            return client;
        });
    }
    setPrice(price) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.program.methods
                .updatePrice(price)
                .accounts({
                payer: this.provider.publicKey,
                state: this.stateAddress,
            })
                .rpc();
        });
    }
}
exports.YieldControllerClient = YieldControllerClient;
//# sourceMappingURL=../src/dist/index.js.map